import moment from 'moment';
import { useRouter } from 'next/router';

import { useCallback } from 'react';
import { AttributeList, authService } from '../account/AuthService';
import bookingSlice from '../booking/slice';
import useAppDispatch from '../redux/useAppDispatch';
import cookie from '../helpers/cookie';
import { useSelector } from '../redux/store';

const useStoreAffiliateParameter = (): typeof storeParameter => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const affiliate = useSelector((x) => x.booking.affiliate);

  const storeParameter = useCallback(async () => {
    const url = new URL(window?.location?.href);

    const expiry = moment().add(90, 'days').valueOf();

    // Ensure that cognito store the affiliate id from redux
    const a8Affiliate = url.searchParams.get('a8') || affiliate?.a8?.id;
    // TODO should we remove the id from URL once we set in redux state?
    if (a8Affiliate) {
      // Only update if the affiliate id is different
      if (a8Affiliate !== affiliate?.a8?.id) {
        dispatch(
          bookingSlice.actions.setAffiliateParameter({
            a8: {
              id: a8Affiliate,
              expiry,
            },
          })
        );
      }

      const attributes: AttributeList = [
        {
          Name: 'custom:a8_parameter_id',
          Value: a8Affiliate,
        },
        {
          Name: 'custom:a8_parameter_expiry',
          Value: expiry.toString(),
        },
      ];

      if (await authService.getCurrentUser()) {
        await authService.updateAttributes(attributes, router.locale);
      }
    }

    const affiliateId = url.searchParams.get('affiliate_id') || cookie.affiliate_id.get();
    if (affiliateId) {
      // Only update if the affiliate id is different
      if (affiliateId !== affiliate.id || !cookie.affiliate_id.get()) {
        cookie.affiliate_id.set(affiliateId);
        dispatch(bookingSlice.actions.setAffiliateIdParameter(affiliateId));
      }
    } else {
      dispatch(bookingSlice.actions.setAffiliateIdParameter(undefined));
    }
  }, [affiliate?.a8?.id, affiliate.id, dispatch, router.locale]);
  return storeParameter;
};

export default useStoreAffiliateParameter;
